import {partition} from '@benchling/js-utils';

export interface NormalizedRun {
  id: string;
  status: string;
  createdAt: string;
  modelName?: string;
  displayName?: string;
  iconPath?: string;
  properties?: Record<string, unknown> | null;
}

export const PREDICTION_RUNS_POLL_INTERVAL_MS = 45_000;

const PENDING_STATUSES = new Set(['PENDING', 'RUNNING', 'WAITING']);
const COMPLETED_STATUS = 'SUCCEEDED';

function byCreatedAtDesc(a: NormalizedRun, b: NormalizedRun): number {
  return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
}

export function splitPredictionRuns(runs: ReadonlyArray<NormalizedRun>): {
  pendingRuns: Array<NormalizedRun>;
  completedRuns: Array<NormalizedRun>;
} {
  const [pendingRuns, remainingRuns] = partition(runs.slice(), (run) => PENDING_STATUSES.has(run.status));
  const completedRuns = remainingRuns.filter((run) => run.status === COMPLETED_STATUS);
  return {
    pendingRuns: pendingRuns.slice().sort(byCreatedAtDesc),
    completedRuns: completedRuns.slice().sort(byCreatedAtDesc),
  };
}
